import React, { FC } from "react";
import { useFormState } from "react-final-form";
import { makeStyles } from "@material-ui/core";
import CircularProgress from "../../../../components/CircularProgress";
import FontIcon from "../../../../components/FontIcon";
import { IWizardStepContent } from "../../../wizard/types";

const useStyles = makeStyles(() => ({
  main: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: 200,
  },
  text: {
    fontSize: 18,
    color: "#858997",
    fontWeight: "bold",
    marginTop: -5,
    marginBottom: 14,
  },
  benefitsContainer: {
    margin: "38px 0",
  },
  iconTextContainer: {
    display: "flex",
    "& + &": {
      marginTop: 12,
    },
  },
  icon: {
    fontSize: 22,
    color: "#7ec884",
    paddingTop: 1,
    height: 24,
    width: 24,
  },
  benefitsText: {
    paddingLeft: 12,
  },
}));

export const CreditsContent: FC<IWizardStepContent> = () => {
  const classes = useStyles();
  const { values } = useFormState();

  let packageName;
  let percent;
  let credits;
  let textColor;
  let benefits = [];

  if (values.currentPackage === null) {
    packageName = "No package";
    percent = 0;
    credits = "0";
    textColor = "#F8202D";
  } else if (values.availableCredits === 0) {
    packageName = values.currentPackage.name;
    percent = 0;
    credits = "0";
    textColor = "#F8202D";
    benefits = values.currentPackage.benefits;
  } else {
    packageName = values.currentPackage.name;
    percent = Math.round(
      (values.availableCredits / values.currentPackage.credits) * 100,
    );
    credits = `${values.availableCredits}`;
    textColor = "#858997";
    benefits = values.currentPackage.benefits;
  }

  return (
    <div className={classes.main}>
      <span className={classes.text}>{packageName}</span>
      <CircularProgress
        percent={percent}
        size={"132px"}
        text={credits}
        textColor={textColor}
      />
      {!!benefits.length && (
        <div className={classes.benefitsContainer}>
          {benefits.map((benefit, index) => (
            <div className={classes.iconTextContainer} key={index}>
              <FontIcon name={"feature"} className={classes.icon} />
              <div className={classes.benefitsText}>{benefit}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
